function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4059 13.125H13.5937C12.9909 13.125 12.4996 13.6153 12.4996 14.2191V15.7819C12.4996 16.3847 12.9899 16.8759 13.5937 16.8759H21.4059C22.0096 16.875 22.5 16.3847 22.5 15.7809V14.2181C22.5 13.6153 22.0096 13.125 21.4059 13.125Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4059 18.75H13.5937C12.9909 18.75 12.4996 19.2403 12.4996 19.8441V21.4069C12.4996 22.0097 12.9899 22.5009 13.5937 22.5009H21.4059C22.0096 22.5 22.5 22.0097 22.5 21.4059V19.8431C22.5 19.2403 22.0096 18.75 21.4059 18.75Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 16.875C10.4105 16.875 11.25 16.0355 11.25 15C11.25 13.9645 10.4105 13.125 9.375 13.125C8.33947 13.125 7.5 13.9645 7.5 15C7.5 16.0355 8.33947 16.875 9.375 16.875Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4059 7.5H13.5937C12.9909 7.5 12.4996 7.99031 12.4996 8.59406V10.1569C12.4996 10.7597 12.9899 11.2509 13.5937 11.2509H21.4059C22.0096 11.25 22.5 10.7597 22.5 10.1559V8.59406C22.5 7.99031 22.0096 7.5 21.4059 7.5Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 11.25C10.4105 11.25 11.25 10.4105 11.25 9.375C11.25 8.33947 10.4105 7.5 9.375 7.5C8.33947 7.5 7.5 8.33947 7.5 9.375C7.5 10.4105 8.33947 11.25 9.375 11.25Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 22.5C10.4105 22.5 11.25 21.6605 11.25 20.625C11.25 19.5895 10.4105 18.75 9.375 18.75C8.33947 18.75 7.5 19.5895 7.5 20.625C7.5 21.6605 8.33947 22.5 9.375 22.5Z"
});

function SvgForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.01d69fb5.svg";
export { ForwardRef as ReactComponent };